import Acker from './acker.png';
import AnikaOsthoff from './logo-placeholder.png';
import AoGrenzen from './aog.png';
import Auer from './auer.png';
import Aulis from './aulis.png';
import Bange from './bange.png';
import Bettermarks from './bettermarks.png';
import Betzold from './betzold.png';
import CarlAuer from './carl-auer.png';
import cleverly from './cleverly.png';
import DFS from './dfs.png';
import DKJS from './dkjs.png';
import DKH from './die-kleine-heldenschmiede.png';
import dpaInfografik from './dpa.png';
import Edeos from './edeos.png';
import eduhu from './eduhu.png';
import elkVerlag from './elk-verlag.png';
import eDidact from './edidact.png';
import Freyspiel from './schoolgames.png';
import Friedrich from './friedrich.png';
import FSelbstkontrolleM from './fsm.png';
import GundaFrey from './gunda-frey.png';
import Grandfilm from './grandfilm.png';
import Herolé from './herole.png';
import HHP from './logo-placeholder.png';
import JV from './junfermann-verlag.png';
import JO from './jung-oesterreich.png';
import KICampus from './ki-campus.png';
import klettLerntraining from './klett-lerntraining.png';
import klettKallmeyer from './klett-kallmeyer.png';
import KlettMEX from './klettmex.png';
import Klinkhardt from './klinkhardt.png';
import Klippert from './klippert.png';
import KommaKlar from './komma-klar.png';
import Langenscheidt from './langenscheidt.png';
import Lernbiene from './lernbiene.png';
import LetsMINT from './lets-mint.png';
import MatthiasZeitler from './matthias-zeitler.png';
import Medienblau from './on-interaktiv.png';
import MedienLB from './medienlb.png';
import meinUnterricht from './mein-unterricht.png';
import MichaelFromm from './logo-placeholder.png';
import Mildenberger from './mildenberger.png';
import Oxfam from './oxfam.png';
import Persen from './persen.png';
import pictureAlliance from './pa.png';
import PONS from './pons.png';
import Raabe from './raabe.png';
import RKT from './raphael-kirsch-training.png';
import SchilfAkademie from './schilf-akademie.png';
import Schulfilme from './schulfilme.png';
import Schulflix from './schulflix.png';
import scolix from './scolix.png';
import StarkInsNeue from './stark-ins-neue.png';
import Studyflix from './studyflix.png';
import Teachino from './teachino.png';
import TerraX from './terraX.png';
import UNICEF from './unicef.png';
import UTB from './utb.png';
import VuR from './vur.png';
import Welttierschutz from './wtg.png';
import wheelmap from './wheelmap.png';
import YAEZ from './yaez.png';
import YCC from './your-cool-control.png';

const publisher = {
  Acker,
  'Anika Osthoff': AnikaOsthoff,
  AoGrenzen,
  Auer,
  Aulis,
  Bange,
  Bettermarks,
  Betzold,
  'Carl-Auer': CarlAuer,
  cleverly,
  DFS,
  DKJS,
  'Die kleine Heldenschmiede': DKH,
  'dpa-infografik': dpaInfografik,
  Edeos,
  'elk Verlag': elkVerlag,
  eDidact,
  eduhu,
  EKS: klettLerntraining,
  Freyspiel,
  Friedrich,
  FSelbstkontrolleM,
  'Gunda Frey': GundaFrey,
  Grandfilm,
  Herolé,
  'Heck Health & Performance': HHP,
  'JPP Medien': Schulfilme,
  'Junfermann Verlag': JV,
  'JungÖsterreich': JO,
  'KI Campus': KICampus,
  'Klett Lerntraining': klettLerntraining,
  KlettMEX,
  'Klett Kallmeyer': klettKallmeyer,
  Klinkhardt,
  Klippert,
  'Komma Klar': KommaKlar,
  Langenscheidt,
  Lernbiene,
  LetsMINT,
  'Matthias Zeitler': MatthiasZeitler,
  Medienblau,
  MedienLB,
  meinUnterricht,
  MGO: eDidact,
  Mildenberger,
  'Michael Fromm': MichaelFromm,
  Oxfam,
  Persen,
  'picture-alliance': pictureAlliance,
  PONS,
  Raabe,
  'Raphael Kirsch Training': RKT,
  SchilfAkademie,
  Schulflix,
  scolix,
  'Stark ins Neue': StarkInsNeue,
  Studyflix,
  Teachino,
  TerraX,
  UNICEF,
  UTB,
  VuR,
  Welttierschutz,
  wheelmap,
  YAEZ,
  'yourCOOLcontrol': YCC,
};

export default publisher;
